import lazyLoading from '../../utils/lazyLoading'

export default {
  hidden: false,
  createroutes: true,
  name: 'admin_clubs',
  path: '/admin/clubs/:club_id?',
  props: true,
  exact: true,
  component: lazyLoading('admin/clubs/Clubs'),
  meta: {
    label: 'Clubs',
    permission: 'ADCLV',
    icon: 'mdi-account-group',
    expanded: false,
    link: 'admin/clubs/Clubs.vue'
  }
  /* children: [
    {
      name: 'Clubs',
      path: '/admin/clubs',
      meta: {
        permission: '*',
        link: 'admin/Clubs.vue'
      },
      component: lazyLoading('admin/Clubs')
    },
    {
      name: 'Leden',
      path: '/admin/members',
      meta: {
        permission: '*',
        link: 'admin/Members.vue'
      },
      component: lazyLoading('admin/Members')
    }
    ] */
}



// WEBPACK FOOTER //
// ./src/store/menu/clubs.js